import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Notification } from '@tanium/react-persistent-notifications';
import { Shimmer } from '@tanium/react-shimmer';
import { AsyncStateData } from '../../hooks/useAsync';
import { AsyncSuspense } from '../AsyncSuspense';
import { ValidateIdpResponse } from '../../models/IdpModels';

interface IdpMetadataValidationBannerProps {
  asyncValidation: AsyncStateData<ValidateIdpResponse>;
}

export const IdpMetadataValidationBanner: React.VFC<IdpMetadataValidationBannerProps> = ({ asyncValidation }) => {
  const { t } = useTranslation();
  const bannerNotification = useMemo((): JSX.Element => {
    const fileValidation = asyncValidation.value;
    if (fileValidation?.result === false) {
      return (
        <Notification role="status" type="error">
          {fileValidation?.message}
        </Notification>
      );
    }
    return fileValidation?.message ? (
      <Notification role="status" type="warning">
        {fileValidation?.message}
      </Notification>
    ) : (
      <Notification role="status" type="success">
        {t('Metadata validation succeeded')}
      </Notification>
    );
  }, [asyncValidation.value, t]);

  return <AsyncSuspense state={asyncValidation} loading={<Shimmer />} failure={<></>} children={bannerNotification} />;
};
